export default function Forward() {
  return (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15">
    <g id="Mask_Group_261" data-name="Mask Group 261">
      <path id="reply-message" d="M8.75,4.376V1.719a.468.468,0,0,1,.8-.336l5.313,5.156a.468.468,0,0,1,0,.673L9.545,12.368a.468.468,0,0,1-.8-.336V9.375H7.864A7.97,7.97,0,0,0,.893,13.483l-.013.024a.469.469,0,0,1-.411.244.463.463,0,0,1-.116-.014A.469.469,0,0,1,0,13.281,8.917,8.917,0,0,1,8.75,4.376Z" transform="translate(0)" fill="#404040" />
    </g>
  </svg>)
}

